<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
     ref="editForm"
    >
      <!-- 0 线上 1 线下 -->
      <el-row>
        <el-form-item label="是否线下" prop="isOutLine">
          <el-checkbox
            size="small"
            :false-label="0"
            :true-label="1"
            v-model="editForm.isOutLine"
            placeholder="是否线下"
          ></el-checkbox>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="所在户" prop="account">
          <el-select size="small" v-model="editForm.account" placeholder="请选择">
           <el-option
                  v-for="type in addTableData"
                  :label="type.value"
                  :value="type.key"
                  :key="type.value"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-row>

       <el-row>
        <el-form-item label="客户类型" prop="cusType">
          <el-select size="small" v-model="editForm.cusType" placeholder="请选择">
           <el-option
                  v-for="type in customerType"
                  :label="type.value"
                  :value="type.key"
                  :key="type.value"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-row>


      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { listSalesman } from "@/api/system/user";
import { backTicket } from "@/api/ticket/ticket";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
     editForm: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      addTableData:[
      {"key":"a","value":"    A"},
        {"key":"b","value":"    B"},
        {"key":"c","value":"    C"},
        {"key":"d","value":"    D"},
        {"key":"e","value":"    E"},
        {"key":"f","value":"    F"},
        {"key":"g","value":"    G"},
        {"key":"h","value":"    H"},
      ],
       customerType:[
        {"key":"C_1","value":"公司客户"},
        {"key":"C_2","value":"中介"},
        {"key":"C_3","value":"终端客户"},
      ]
    };
  },
  methods: {
    handleSubmit() {
     backTicket(this.editForm)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.warning);
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("confirm");

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-store/add-edit/back.vue